import { PlusOutlined } from "@ant-design/icons";
import Card from "../Card/Card";
import "./AddCard.scss";

function AddCard({ Mode, handleNavigate, openModal }) {
  return (
    <div className="add-card">
      <Card>
        {(() => {
          switch (Mode) {
            case "Course":
              return (
                <PlusOutlined
                  className="add-card-icon"
                  onClick={handleNavigate}
                />
              );
            case "Training":
              return (
                <PlusOutlined className="add-card-icon" onClick={openModal} />
              );
              case "Event":
                return (
                  <PlusOutlined className="add-card-icon" onClick={openModal}/>
                );
            default:
              return null;
          }
        })()}
      </Card>
    </div>
  );
}
export default AddCard;
